export default "__VITE_ASSET__w0Yb3cOx__"